import React, { Component } from 'react';
import "./newproduct.css"
import  AuthService  from "../api/authentication.js";
import  Addinput from "./addinput"
import axios from 'axios';
import    Getdata  from "./inputdata"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
    Link,
  } from 'react-router-dom'
  const Auth = new AuthService();
  const dataView = [
    
  ];
  var dataE = [
    {},
    {}, 
]

 var currencyC = [
   "Naira"
 ]
  
class  NewProduct extends Component {
    
    constructor(props){
        super(props)
        this.state ={
          user :[],
          tuitions:[],
          noerorrpage:true,
          domain: 'https://uvune-listing.herokuapp.com',         
          domainLOCAL: ' http://localhost:3030',      
          imageShow:false,
          count : 0,
          disabled : false,
          photos : [],
          images: [],
          imageUrls : [],
          details : [],
          categories:[],
          catalog:[],
          getCategory:"",
          id : "",
          ifsubmit : false,
          ifCatalog:false,
          ifCategory:false,
          showCategory:false,
          firstCategory :[],
          loanData:true,
          loadingcategory:false,
          photoInput:dataE ,
          imageError:false,
          currency:[],
          selectCurrency:"",
          unit:[],
          selectUnit:"", 
          groupCategory:[],
        
          isChecked: false,
        }
      }


      componentWillReceiveProps(nextProps) {
		

        if (nextProps.organizer) {
      
          this.setState({
            // isAuthenticated: nextProps.isAuthenticated,
            organizer: nextProps.organizer,       
          });
        
          // this.getDashboardDatas(nextProps.user);
          // this.GetCategory(nextProps.organizer.category);
        }
      }
  
  
    
      componentDidMount(){
        // console.log("dash users=====================", this.props.user)
          this.props.noerorrpage(this.state.noerorrpage)
          // this.GetCategory()
          this.setState ({
            currency:currencyC,
             selectCurrency:currencyC[0],
             unit:unitC,
             selectUnit:unitC[92]
           })
          const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
            //  body: JSON.stringify(data),
          };

          fetch(this.state.domain+"/category-group?$limit=30/", requestOptions )
          .then(res => res.json())
          .then(res => {
              // console.log("error state this.state. getreview==----===----> ", res.data)
                  this.setState({
                    groupCategory : res.data,
                    // getfirstCate : res.data[0],
                    loanData : false,
                    product:res,
                    
                  })  
          })
        
         
        
       }

        
showInput=(e)=>{
    e.preventDefault()
  this.setState({
    showAdd:true
  })
    // console.log(w)

}

getdata=(data)=>{
    // event.preventDefault();
    // console.log("data ==------>",data);
    const  details  = this.state.details
         details.push({
            field : data.field,
            value : data.value,
            
        })
   this.setState({details})
}

selectImages = (event) => {
  event.preventDefault();
// let images = []
let photo  = []
var images =     this.state.images
var regex = new RegExp("([a-zA-Z0-9\s_\\.\-:])+(.jpg|.png|.gif)$");
for (var i = 0; i <  event.target.files.length && i < 5 ; i++) {
  
    photo[i] =  URL.createObjectURL(event.target.files.item(i))
    // console.log("data ===---->first file",event.target.files.item(i))
    if(event.target.files.item(i).size > 3309874) {
        toast("Sorry image is too bigger then 130 KB");
      //  console.log("datat size yes", event.target.files.item(i).size  )
    }else{
      // console.log("datat size no", event.target.files.item(i).size  )
      if (event.target.files.item(i).name.match(/\.(jpg|jpeg|png|gif)$/)) {
       
        var reader = new FileReader();
      
        
      reader.readAsDataURL(event.target.files.item(i))
     
        reader.onload = (e) => {
          let imgDimWarning = false;
            //Initiate the JavaScript Image object.
            // console.log("error",e)
            var image = new Image();
           

            //Set the Base64 string return from FileReader as source.
            image.src = e.target.result;
                  
            //Validate the File Height and Width.
              // console.log("width", image.width, image.width)
               image.onload = ()=>{

                // console.log("width", image.width, image.height)
                if (image.height > 800 || image.width > 800) {
                      // alert("Height and Width must not exceed 100px.");
                      // console.log("data=====----->yes")
                       this.setState({imageError:false})
                       toast("Height and Width most not exceed 800px");
                  }else{
                      //  console.log("lolol--------> no", image)
                          this.setState({imageError:true})
                          
                         let images =  this.state.images
                          images.push(image.src)

                            this.setState({
                              images: images
                     })
                  }   
              }
          }
        }else{
        toast("Image only jpg | jpeg | png | gif");
      }
    }
   
 }

 

if(event.target.files.length  !== 0){
    this.setState({
      ifImage :true,
      editImage :true
    })
    }else{
      this.setState({
        ifImage :false
      })
    }

}




uploadImages=(event) => {
    event.preventDefault();
          this.setState({
            ifsubmit:true,
            loadingButton: true 
          }) 
      if(this.state.ifCatalog) {
          if(!this.state.isChecked) {
            const data ={
              name :this.name .value,
              max_price :this.maxprice.value,
              min_price :this.minprice.value,
              moq : this.moq.value,
              summary : this.summary.value,
              company_id : this.props.organizer._id,
              quick_details : this.state.details,
              catalog:this.state.getCategory,
              currency : this.state.selectCurrency,
              negotiable:false,
              measure:this.state.selectUnit
          }
          // console.log("data --=-----> second", data)
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
            body: JSON.stringify(data),
        };
        //  console.log(" requestOptions",  requestOptions)
        fetch(this.state.domain + "/products", requestOptions)
        .then(res => res.json())
        .then((res)=>{
            // console.log("data, rest--==--->", res)
            if(res.code === 400 ){
                // console.log("data, rest--==---> false", res)
                toast("Sorry wrong input check  !");
                this.setState({
                  ifsubmit:false,
                  loanData:false
                }) 
                
                }else{
                    // console.log("data, rest--==---> true", res)
                  if(this.state.images.length !== 0){
                    this.pushImage(res)
                    }else{
                      this.props.history.replace({
                        pathname: '/product/'+ res._id,
                        // state: { detail: res}
                        state: { notice: "true" , message:"Create Event" }
                        })
                }
            } 
        })

        }else{
              const data ={
                name :this.name .value,
                // max_price :this.maxprice.value,
                // min_price :this.minprice.value,
                // moq : this.moq.value,
               
                negotiable:true,
                summary : this.summary.value,
                company_id : this.props.organizer._id,
                quick_details : this.state.details,
                catalog:this.state.getCategory,
                // currency : this.state.selectCurrency,
                measure:this.state.selectUnit
            }
            // console.log("data --=-----> second", data)
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
              body: JSON.stringify(data),
          };
          //  console.log(" requestOptions",  requestOptions)
          fetch(this.state.domain + "/products", requestOptions)
          .then(res => res.json())
          .then((res)=>{
              // console.log("data, rest--==--->", res)
              if(res.code === 400 ){
                  // console.log("data, rest--==---> false", res)
                  toast("Sorry wrong input check  !");
                  this.setState({
                    ifsubmit:false,
                    loanData:false
                  }) 
                  
                  }else{
                      // console.log("data, rest--==---> true", res)
                    if(this.state.images.length !== 0){
                      this.pushImage(res)
                      }else{
                        this.props.history.replace({
                          pathname: '/product/'+ res._id,
                          // state: { detail: res}
                          state: { notice: "true" , message:"Create Event" }
                          })
                      }

                  
                    
              }
                    
                
          })
  
        }    

           
      
        
      }else{
        toast(" Input add data  !");
      }
  
 }

 pushImage=(data) => {
// console.log("create -->",data)
    this.setState({
      loanData:true,
      loanData : true,
    })
   const uploaders = this.state.images.map(image => {
        const formData = new FormData();
        //  console.log('done image---->', image );
        formData.append('uri', image );
        formData.append('product_images', true);
        formData.append('product_id', data._id);
        const options = {
            method: 'POST',
            headers: { 
                'content-type': 'multipart/form-data',
            'access-control-allow-origin': '*',
            'Authorization': Auth.getToken(), 
            },
        url:this.state.domain+"/upload-logo",
 };
   // Make an AJAX upload request using Axios
   return  axios.post(options.url, formData, options.headers)
   .then(response => {
        //  console.log("response", response.data.uri)
        //  const productImage  = this.state.productImage
        //  productImage.push(
        //              response.data.uri
        //       )
        //  this.setState({
        //      productImage:productImage
        //   //  imageUrls: [response.data.result, ...this.state.imageUrls ]
        //    });
         
       })
      
 });
 
   // Once all the files are uploaded 
     axios.all(uploaders).then(() => {
      //  this.forceUpdate(this.state.imageUrls)
      this.props.history.replace({
        pathname: '/product/'+ data._id,
        // state: { detail: res}
        state: { notice: "true" , message:"Create Event" }
        })
      this.setState({
        loanData:false,
        editImage:false
      })
        //  console.log('done');
     }).catch(err => alert(err.message));



}

newEdit=(data)=>{

    let detailss  = this.state.details
    // console.log("data",  detailss)
   var details  = detailss.filter((details , i)=>{
        if(i  == data.id){
            // console.log("------judge1 yes found i"   )
            // details.ID     =    data.id
            details.field    =    data.field
            details.value    =    data.value
            // console.log("------judge", details.field ," messid",  details.value  )
        }
        
        return details
     })
  this.setState({
      details
    })
    

}


onDelete=(id)=>{
    // console.log("conselo==------>",id)
    const  messages  =  dataView
     const fitleredmeassages = this.state.details.filter(( meassage ,i ) =>{
        // console.log("conselo==------> ooo",i)
       return i !== id
     })
    //  console.log(fitleredmeassages)
     this.setState({details:fitleredmeassages})
}
    




  closeCategory = (e)=>{
    e.preventDefault();
    this.setState({
      showCategory:false
    })

  }

  updateCategorytime() {
    //  console.log("data---====--==>",data)
     setTimeout(function() {
         this.setState({
             erorrDiv : false,
             showCategory:false,
             loadingcategory:false
         })
     //   console.log(this.state.noticeshow);
     }.bind(this), 4000);
  }


  selectSubcategory  = (e)=>{
    //  console.log("data--===------> category", e.target.value)
    this.setState({
       loanData:true,
      // getCategory: e.target.value
    })
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
      //  body: JSON.stringify(data),
    };
  
    fetch(this.state.domain+"/catalog?$limit=40&category="+e.target.value, requestOptions )
    .then(res => res.json())
    .then(res => {
            // console.log("error state this.state. getreview==----===----> ", res.data)
           this.setState({
            catalog:res.data,
            ifCategory:true,
            loanData:false
           }) 
    })
  
 }


selectCategory = (e)=>{
    //  console.log("data--===------> category", e.target.value)
    this.setState({
       loanData:true,
      // getCategory: e.target.value
    })

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*', 'Authorization': Auth.getToken(),  },
      //  body: JSON.stringify(data),
    };
  
    fetch(this.state.domain+"/category?$limit=40&group_id="+e.target.value, requestOptions )
    .then(res => res.json())
    .then(res => {
          //  console.log("error state this.state. getreview==----===----> ", res.data)
           this.setState({

            categories:res.data,
            ifCategory:true,
            loanData:false
           }) 
    })
  
 }

 selectCatalog  = (e)=>{
  // console.log("data--===------> category", e.target.value)
      this.setState({
          ifCatalog:true,
          getCategory: e.target.value
      })
}

selectcurrency = (e) =>{
  // console.log("data--===------> selectcurrency", e.target.value)
  this.setState({
    // ifCatalog:true,
    selectCurrency: e.target.value
})
}

Unitselect = (e) =>{
  // console.log("data--===------> selectcurrency", e.target.value)
  this.setState({
    // ifCatalog:true,
    selectUnit: e.target.value
})
}

  deletePhoto = (data)=>{ 
    // console.log("datta----->", data)
    // const  messages  =  data
    const fitleredmeassages = this.state.images.filter(( meassage ,i) =>{
      // console.log("conselo==------> ooo",i)
      return i !== data
    })
      // console.log("data,----->update ",fitleredmeassages.length)
    this.setState({images:fitleredmeassages})

  }
  
  Showcategory= (e)=>{
    e.preventDefault()
    this.setState({
       showCategory: true
    })
  }
  
   
  toggleChange = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
    // console.log("checking--->1", this.state.isChecked)
  }

  render() {

    // console.log("checking--->2", this.state.isChecked)
    //  console.log("data log org",this.state.selectUnit)
    // console.log("dash =======-", this.props.isActive)

  //  console.log("dash disable=======-", this.props.disableLink)
    return (
      
        <div id="dashboard-wrapper " class="columns dashboard-cousom">
            <ToastContainer />
                 {this.state.loanData?
                //   <Leader/>
                    <div class="pre-loader">
                  <div class="loader"></div>
                </div> 
                      :
                      <div></div>
               }
            {/* <div class="column"></div>
            <div class="content column is-11"> */}
        
                {/* <!-- Breadcrumbs --> */}
                <nav class="breadcrumbs">
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li>New Product</li>
                    </ul>
                </nav>
                <br/>
                
            <div className="new-product-body"> 
            
               

           
              {
                 this.state.showCategory?
                   <div style={{width:"60%", margin:"auto"}}>
                      <div class="flex-card light-bordered light-raised">
                          
                            <div class="content has-text-centered mt-20">
                            <form  onSubmit={this.Addcategory}>
                            <div className="newproduct-category-form" >
                                <h3>Create Category</h3>
                                <br/>
                                       <div> 
                                         
                                            <p className="control has-icons-left has-icons-right">
                                                                          <input
                                                                         
                                                                          ref={ input => this.name = input} 
                                                                          defaultValue={ this.props.name}
                                                                          className="input" type="tel" 
                                                                          placeholder="Category name"/>
                                                                          <span className="icon is-small is-left">
                                                                          <i className="fas fa-tags">  </i> 
                                                                          </span>
                                                </p>
                                                  
                                          </div>
                                          
                                              <input className="input" type="hidden" ref={input => this.id = input} defaultValue={ this.props.id} placeholder="More Information"  required/>  
                                              <br/>
                                              {
                                                !this.state.loadingcategory?
                                                <div className="">
                                                  <button className="button is-small is-success button-style" >Save</button>
                                                  <a className="button is-small is-link " onClick={this.closeCategory}>Close</a>
                                                </div>
                                                :
                                                <div className="level-item">
                                                    <a className="button is-loading is-large is-light">Loading</a>
                                                </div>   

                                              }
                                         </div>   
                                            
                                            
                                        </form>
                            </div>
                          </div>  
                   </div>
                 :
                 <div class="flex-card light-bordered light-raised">
                 <div class="card-body">
                     <h2 class="title is-4 text-bold mb-20">Create Product </h2>
                     <br/>

                     <div class="columns">
                     {
                        this.state.groupCategory?
                            <div class="column is-half">
                              <label>Category</label>
                             {
                                 this.state.groupCategory.length > 0 ? (

                                  <div class="control">
                                      <div className={this.state.groupCategory.length > 0 ?"select is-loadin":"select" }>
                                        <select class="is-focused" style={{width:"380px"}} onChange={this.selectCategory} value={this.state.select}>
                                        <option>       --- Select category  ---</option>
                                          {
                                            this.state.groupCategory.map(data => {
                                                  return  <option key={data._id} value={data._id}>{data.name}</option>
                                              })
                                          }
                                        </select>
                                      </div>
                                    </div>  
                                   )
                                 :
                                <div></div>
                               }
                            </div>
                            
                            :
                          <div>

                          </div>
                      } 
                       {
                       this.state.categories?
                            <div class="column ">
                            
                             {
                                 this.state.categories.length > 0 ? (
                                  <div>
                                    <label>Sub category</label>
                                    <div class="control">
                                        <div className={this.state. categories.length > 0 ?"select is-loadin":"select" }>
                                          <select class="is-focused" style={{width:"380px"}} onChange={this.selectSubcategory} value={this.state.select}>
                                          <option>       --- Select category  ---</option>
                                            {
                                              this.state. categories.map(data => {
                                                    return  <option key={data._id} value={data._id}>{data.name}</option>
                                                })
                                            }
                                          </select>
                                        </div>
                                      </div>
                                
                                  </div>
                                    
                                   )
                                 :
                                <div></div>
                               }
                            </div>
                            
                            :
                          <div>

                          </div>
                         }
                    </div>
                    <div class="columns">
                      {
                         this.state.catalog?
                          <div class="column is-half">
                                {
                                 this.state.catalog.length > 0 ? (
                                 <div>
                                    <label>Subcategory</label>
                                  <div class="control">
                                      <div class="select ">
                                        <select class="is-focused"   style={{width:"380px"}} onChange={this.selectCatalog} value={this.state.select}>
                                          <option>   --- Select subcategory --- </option>
                                          {
                                            this.state.catalog.map(data => {
                                                  return  <option key={data._id} value={data._id}>{data.name}</option>
                                              })
                                          }
                                        </select>
                                      </div>
                                    </div>
                                  </div>  
                                 )
                                :
                                <div>
                                  
                                </div>
                               }
                            </div>
                            
                            :
                          <div></div>
                         }
                     
                       <div className="column"></div>


                       </div>

                     
                       <br/>
                          {
                            this.state.ifCatalog ?
                            <div> 
                                <b>
                                  <small>Product with photo get 5x more clients. </small>
                                </b> 
                              <small>
                                 Accepted formats are .jpg, .gif and .png. Max allowed size for uploaded files is 3 MB ,  Suggested dimensions: 800x800px.
                              </small>
                              <br/>
                              <br/>
                            <div class="newproduct-wrapper">


                               {
                                     this.state.images.map((url, i) => (
                                       <div class="newproduct-a">
                                          <a onClick={() => this.deletePhoto(i)}><i class="fas fa-trash-alt"  style={{color:"red",float:"right",position:"relative",top:"30px"}}></i></a>
                                         <div  key={i} style={{position:"relative",top:"60px",marginLeft:"10px"}}>
                                             <img src={url} className="" width="150"
                                             alt="not available"/>
                                         </div>
                                       </div>
                                     ))
                               }
                               {
                                  this.state.photoInput.map((url, i) => {
                                     return( 
                                       <div class="newproduct-a" key={i}>
     
     
                                           <div>
                                             <input type="file" 
                                             id="file" onChange={this.selectImages} multiple/>
                                             <label for="file" >
                                             <br/>
                                             <br/>
                                             <i class="fas fa-camera" style={{fontSize:"210%",textAlign:"center",position:"relative",bottom:"13px",color:"#00d1b2"}}></i> <br/>
                                                 
                                             </label>
                                           </div>
                                          
                                     
                                       </div>
                                       )
                                   })
     
                                }
                             </div>
                         </div>
                         :
                         <div></div>
                          }
                   

                       <br/>

                  <form onSubmit={this.uploadImages}>
                         
                         <div class="columns mt-50">
                            <div class="column">
                                <div class="control">
                                    <label>Product name</label>
                                    <input class="input is-medium mt-5"  ref={input =>this.name = input} placeholder="Product name" required type="text"/>
                                </div>
                             </div>
                             <div class="column">
                                  <div class="control">
                                     <label> Min order</label>
                                     <input class="input is-medium mt-5" type="number" ref={input =>this.moq = input} placeholder="Minimum" required />
                                  </div> 
                                    
                                </div>
                              
                            </div>
                            
                            <div class="columns mt-50">
                            <div class="column">
                              <div style={{float: `${!this.state.isChecked? "right" : 'left'}`, width:"100px",height: `${!this.state.isChecked? "5px" : '50px'}`,position:"relative",top: `${!this.state.isChecked? "35px" : '10px'}`,left: `${!this.state.isChecked? "6PX" : ''}`}}>
                              
                                <div className="newproduct-checkbox">
                                    <label>
                                          <input type="checkbox"
                                            checked={this.state.isChecked}
                                            onChange={this.toggleChange}
                                          />
                                          {
                                           !this.state.isChecked? 
                                              <small style={{position:"relative",bottom:"5px", fontSize:"90%"}}>Negotiable</small>
                                            :
                                            <small style={{position:"relative",bottom:"5px"}}>Add Price</small> 
                                          }
                                        
                                    </label>

                                </div>
                               
                               
                              </div>
                              {
                                 !this.state.isChecked? 
                                 <div class="control"  style={{ display: `${!this.state.isChecked? 'block' : 'none'}`,  width:"64%"}}>
                                      <label> Min price</label>
                                      <input class="input is-medium mt-5 productnew-Negoti"  type="number" ref={input =>this.minprice = input} placeholder="Amount" required />
                                  </div>
                                  :
                                  ""
                               }
                               
                              </div>
                                
                            <div class="column" style={{ display: `${!this.state.isChecked? 'block' : 'none'}`}}>
                                {
                                  !this.state.isChecked? 
                                    <div class="control">
                                        <label> Max price</label>
                                        <input class="input is-medium mt-5"  ref={input =>this.maxprice = input} placeholder="Amount" required type="number"/>
                                    </div>
                                   :
                                   ""   

                                }   
                                 
                                  
                            </div>
                                
                                
                            </div>
                            <div class="columns"  >
                            <div class="column is-half" style={{ display: `${!this.state.isChecked? 'block' : 'none'}`}}>
                              <label>Currency</label>
                   

                                  <div class="control">
                                      <div className={this.state.currency.length > 0 ?"select is-loadin":"select" }>
                                        <select class="is-focused" style={{width:"380px"}} onChange={this.selectcurrency} value={this.state.selectCurrency}>
                                        <option  value={this.state.currency[0]}>    {this.state.currency[0]}</option>
                                          {/* {
                                          this.state.currency.map(data => {
                                                  return  <option key={data._id} value={data._id}>{data}</option>
                                              })
                                          } */}
                                        </select>
                                      </div>
                                    </div>   
                                 
                            </div>
                            <div class="column " style={{ display: `${!this.state.isChecked? 'block' : 'none'}`}}>
                              <label>Unit</label>
                   

                                  <div class="control">
                                      <div className={this.state.unit.length > 0 ?"select is-loadin":"select" }>
                                        <select class="is-focused" style={{width:"380px"}} onChange={this.Unitselect} value={this.state.selectUnit}>
                                           {/* <option value={this.state.unit[0]}>  {this.state.unit[0]}    </option> */}
                                          {
                                            this.state.unit.map(data => {
                                                  return  <option key={data} value={data}>{data}</option>
                                              })
                                          }
                                        </select>
                                      </div>
                                    </div>    
                                 
                            </div>
                 
                            
                            

                            
                         
                          </div>




                         <div  className={this.state.isChecked?"new-product-review":"new-product-review-moblie"}>
                             <p><b>Product Feature</b></p> 
                             <div className="new-product-review-sub">
                                 {
                                      this.state.details.length === 0 ?
                                      <div></div>
                                      :
                                      <table class="table is-fullwidth">
                                      <thead>
                                          <tr>
                                              <th>Feature Name </th>
                                              <th>Description</th>

                                              <th></th>
                                          </tr>
                                      </thead>
                                  <tbody>
                                          {
                                              this.state.details.map((message, i)=>{
                                              return(
                                                  
                                              <Getdata
                                                  key={i}
                                                  ID={i}
                                                  field={message.field}
                                                  value = {message.value}
                                                  onDelete={this.onDelete}
                                                  onEdit={this.newEdit}
                                                  editNewMessage={this.newEdit}
                                               />
                                                
                                              )
                                              })
                                          }       
                              </tbody>
                              </table>
                                 }
                                
                                 
                             </div>
                            

                             <Addinput getdata={this.getdata}/>
                             
                         </div>

                         <div class="columns">
                             <div class="column">
                                 <div class="control">
                                     <textarea class="textarea is-grow" rows="5"  ref={input =>this.summary = input} required required  placeholder=" Product Summary ..."></textarea>
                                 </div>
                             </div>   
                         </div>

                         <div style={{width:"50%",margin:"auto",}}>  
                             {
                               this.state.ifsubmit ? 
                               <div className="level-item">
                                   <a className="button is-loading is-large is-light">Loading</a>
                               </div>   
                                 :
                                <div>
                                  {
                                    this.state.ifCatalog ?
                                    <button class="button is-primary is-rounded"value="Submit"  style={{width:"85%"}}>Create</button>
                                    :
                                    <div style={{width:"50%",margin:"auto", textAlign:"center"}}>
                                           <b> Input Category </b> 
                                    </div>
                                  }
                                </div>
                                 
                             }
                           
                         
                         </div>
                     </form> 
                 </div>
             </div>
               

              }
                
               
            </div>
           {/* </div>  */}
        </div>     

    )

}





}

export default NewProduct;


const SelectList = (props) => {

  const optionsItem  =  props.categories.map( (category) => 

      <OptionItem   key={ category._id}  id={category._id} name={category.name} />
  )

      return (
              <select class="chosen-select" data-placeholder="Project category" style={{display: "none"}} onChange={props.handlechangecategory} defaultValue={props.value} className="form-control  font-size-10">
                  {/* <option   selected value="None" > </option> */}

                    { optionsItem }                                                         
                                                                              
                  </select>
                      
              
      )
}

const OptionItem = (props) => {
  //console.log("available props", props);

  return (
          <option  className="landing-page-font-select" value={props.id} > {props.name} </option>

  )
}


var unitC = [
  
  "Acre/Acres",
"Ampere/Amperes",
"Bag/Bags",
"Barrel/Barrels",
"Blade/Blades",
"Box/Boxes",
"Bushel/Bushels",
"buyer/buyers",
"Carat/Carats",
"Carton/Cartons",
"Case/Cases",
"Centimeter/Centimeters",
"Chain/Chains",
"Combo/Combos",
"Cubic Centimeter/Cubic Centimeters",
"Cubic Foot/Cubic Feet",
"Cubic Inch/Cubic Inches",
"Cubic Meter/Cubic Meters",
"Cubic Yard/Cubic Yards",
"Day/Days",
"Degrees Celsius",
"Degrees Fahrenheit",
"Dozen/Dozens",
"Dram/Drams",
"Fluid Ounce/Fluid Ounces",
"Foot/Feet",
"Forty-Foot Container",
"Furlong/Furlongs",
"Gallon/Gallons",
"Gill/Gills",
"Grain/Grains",
"Gram/Grams",
"Gross",
"Hectare/Hectares",
"Hertz",
"Hour/Hours",
"Inch/Inches",
"Kiloampere/Kiloamperes",
"Kilogram/Kilograms",
"Kilohertz",
"Kilometer/Kilometers",
"Kiloohm/Kiloohms",
"Kilovolt/Kilovolts",
"Kilowatt/Kilowatts",
"Liter/Liters",
"Long Ton/Long Tons",
"Megahertz",
"Meter/Meters",
"Metric Ton/Metric Tons",
"Mile/Miles",
"Milliampere/Milliamperes",
"Milligram/Milligrams",
"Millihertz",
"Milliliter/Milliliters",
"Millimeter/Millimeters",
"Milliohm/Milliohms",
"Millivolt/Millivolts",
"Milliwatt/Milliwatts",
"Month/Months",
"Nautical Mile/Nautical Miles",
"Ohm/Ohms",
"Ounce/Ounces",
"Pack/Packs",
"Pair/Pairs",
"Pallet/Pallets",
"Parcel/Parcels",
"Perch/Perches",
"perimeter/square",
"Piece/Pieces",
"Pint/Pints",
"Plant/Plants",
"Pole/Poles",
"Pound/Pounds",
"Quart/Quarts",
"Quarter/Quarters",
"Quarter/Quarters",
"Rod/Rods",
"Roll/Rolls",
"Set/Sets",
"Sheet/Sheets",
"Short Ton/Short Tons",
"Square Centimeter/Square Centimeters",
"Square Foot/Square Feet",
"Square Inch/Square Inches",
"Square Meter/Square Meters",
"Square Mile/Square Miles",
"Square Yard/Square Yards",
"Stone/Stones",
"Strand/Strands",
"Ton/Tons",
"Tonne/Tonnes",
"Tray/Trays",
"Twenty-Foot Container",
"Unit/Units",
"Volt/Volts",
"Yard/Yards"

]


// WEBPACK FOOTER //
// ./src/component/company/newproduct.js